import { ElementsArray } from 'polotno/model/group-model';
import { StoreType } from 'polotno/model/store';

export function deleteElements(store: StoreType, elements: ElementsArray) {
    store.deleteElements(elements.map(element => element.id));
}
